import React, { useState, useEffect, useRef } from "react";
import { ShortsFeed } from "./ShortsFeed";
import { useShortsTranslations } from "./useShortsTranslations";
import { i18n, initializeI18n } from "../../localization/i18n";

const getShortsIdFromUrl = () => {
  try {
    return new URLSearchParams(window.location.search).get("shortsId");
  } catch (e) {
    return null;
  }
};

export function ShortsPage({ props }) {
  const loginUrl = (props && props.loginUrl) || "/auth/login";

  const [currentLanguage, setCurrentLanguage] = useState(null);
  const t = useShortsTranslations(currentLanguage);

  const shortsId = getShortsIdFromUrl();
  const seedRef = useRef(Math.floor(Math.random() * 2147483647));

  useEffect(() => {
    if (!i18n.isInitialized) {
      initializeI18n().then(() => setCurrentLanguage(i18n.language));
    } else {
      setCurrentLanguage(i18n.language);
    }
  }, []);

  return <ShortsFeed t={t} startId={shortsId || null} seed={seedRef.current} loginUrl={loginUrl} />;
}

export default ShortsPage;
